var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaHaushalt2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-9{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#76b72a;}.cls-4{fill:#c7cfe2;}.cls-5{fill:#3b485e;}.cls-6{fill:#add47f;}.cls-7{fill:#8b94a3;}.cls-8{fill:#59667c;}.cls-9{stroke:#3b485e;stroke-linecap:round;stroke-miterlimit:10;stroke-width:1.6px;}.cls-10{fill:#556080;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID",
    className: "cls-1",
    x: 9.41,
    y: 8,
    width: 141.18,
    height: 144
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.88,57.11a2.36,2.36,0,0,1-2.36-2.35v-4.4a9.41,9.41,0,1,0-18.81,0v4.4a2.36,2.36,0,0,1-4.72,0v-4.4a14.13,14.13,0,0,1,28.25,0v4.4a2.36,2.36,0,0,1-2.36,2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M138.85,13c-10.29-6.75-21.2.53-21.2,10.31V130.35h9.41V23.29a3.53,3.53,0,1,1,7.05,0v8.23h9.43V21.86A10.58,10.58,0,0,0,138.85,13Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 18.82,
    y: 123.29,
    width: 9.41,
    height: 23.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 80,
    y: 123.29,
    width: 9.41,
    height: 23.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M54.11,52.7A35.3,35.3,0,0,0,18.82,88v35.3h9.41v18.83H80V123.29h9.41V88A35.3,35.3,0,0,0,54.11,52.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M70.59,137.41H37.65a2.35,2.35,0,1,1,0-4.7H70.59a2.35,2.35,0,1,1,0,4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M70.59,128H37.65a2.36,2.36,0,0,1,0-4.71H70.59a2.36,2.36,0,1,1,0,4.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75.29,88c0,13-9.48,23.53-21.18,23.53S32.94,101,32.94,88s9.48-23.53,21.17-23.53S75.29,75,75.29,88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M61.18,80.94a7.06,7.06,0,1,1-7.07-7,7.06,7.06,0,0,1,7.07,7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 103.53,
    y: 139.76,
    width: 37.65,
    height: 7.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 112.94,
    y: 130.35,
    width: 18.83,
    height: 9.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 117.65,
    y: 80.94,
    width: 9.41,
    height: 9.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M18.82,88a35.24,35.24,0,0,1,2.05-11.74,21.17,21.17,0,0,0-2.05,36.41Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 98.82,
    y1: 146.82,
    x2: 145.88,
    y2: 146.82
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M134.11,37a29.52,29.52,0,0,1-7.05,19.13V69.58l7.81-7.82a29.52,29.52,0,0,0,8.67-20.9V31.52h-9.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M89.41,93.91v13.32L117.65,79V65.68Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaHaushalt2);
export default __webpack_public_path__ + "static/media/ka_haushalt2.419881f04b725907d4029455e60f918c.svg";
export { ForwardRef as ReactComponent };